export const INDUSTRY_BASE_PATH = '/industries/workpiece-by-industry';

export function industryPath(slug: string): string {
  const normalized = slug.replace(/^\/+|\/+$/g, '');
  return `${INDUSTRY_BASE_PATH}/${normalized}/`;
}

export function industrySlugFromPath(pathname: string): string | null {
  const match = pathname.match(
    /^\/industries\/workpiece-by-industry\/([^/]+)\/?$/,
  );
  return match?.[1] ?? null;
}

export function isIndustriesWorkpiecePath(pathname: string): boolean {
  return (
    pathname === `${INDUSTRY_BASE_PATH}` ||
    pathname === `${INDUSTRY_BASE_PATH}/` ||
    pathname.startsWith(`${INDUSTRY_BASE_PATH}/`)
  );
}
